<template>
  <div class="container w-100-mobile">
    <div class="row center-md center-xs">
      <div class="col-sm-11 col-xs-12">
        <h3 v-if="partner && partner.hasOwnProperty('title')" class="center-md center-xs">{{ partner.title }}</h3>
       <div class="col-sm-9 gift-promotion">
         <promo-item v-if="partner && partner.hasOwnProperty('promotions')"/>
       </div>
        <div v-if="partner && partner.hasOwnProperty('about')" class="fs18 mt10 mtmob">
          {{ $t(partner.about) }}
        </div>
        <gifts-box-category-products v-if="categories.length" v-for="category in categories" :category="category" :key="category.entity_id"/>
        <schedule-modal class="modal-schedule"/>
      </div>
    </div>
  </div>
</template>

<script>
import PromoItem from "../components/core/blocks/Shop/Product/PromoItem";
import GiftsBoxCategoryProducts from "../components/theme/GiftsBoxCategoryProducts";
import ScheduleModal from "../components/core/blocks/Shop/Navigation/ScheduleModal";
export default {
  name: "GiftsBox",
  components: {
    PromoItem,
    GiftsBoxCategoryProducts,
    ScheduleModal
  },
  async mounted () {
    await this.$store.dispatch('partners/ensureCurrentPartner', { code: this.$route.name, locationCode: this.$route.params.locationCode });
  },
  computed: {
    partner () {
      return this.$store.getters['partners/getCurrentPartner'];
    }
  },
  watch: {
    partner: {
      async handler () {
        if (this.partner && this.partner.code === 'gift') {
          this.categories = await this.$store.dispatch('products_categories/setCategories', { store: this.partner.code, location_code: this.partner.location_code, size: 12, id: this.partner.root_category_id })
        }
      }
    }
  },
  data () {
    return {
      categories: []
    }
  }
}
</script>

<style lang="scss" scoped>
  .w-100-mobile{
    @media (max-width: 576px) {
      width: 100%;
    }
  }
  .gift-promotion {
    margin: 0 auto;
  }
  .fs18 {
    font-size: 18px;
  }
  .mtmob {
    @media (max-width: 768px) {
      margin-top: 20px!important;
    }
  }
</style>
